import { createContext, useContext } from 'react';

export type Store = 'baby' | 'wedding' | 'home';

type ShopContextValue = {
  store: Store;
  isBaby: boolean;
};

export const ShopContext = createContext<ShopContextValue>({
  store: 'wedding',
  isBaby: false,
});

export const useShopContext = (): ShopContextValue => {
  const context = useContext(ShopContext);
  return context;
};
